import { request } from '../../service/request';
import { IUserInfo } from '../../utils/type';
import { ChatResponse, IHistoryChat, Question } from './type';

/**
 * 获取手机验证码
 * @param params
 * @returns
 */
export const sendMsg = async (params: { content: string }) =>
  request({
    method: 'GET',
    url: '/login/sendMsg',
    params,
  });
/**
 * 获取邮箱验证码
 * @param params
 * @returns
 */
export const sendEmailCode = async (params: { content: string }) =>
  request({
    method: 'GET',
    url: '/login/sendCode',
    params,
  });

interface IEmailLoginData {
  /** 邮箱地址 */
  content: string;
  /** 验证码 */
  code: string;
  /** 语言 zh 中文 en 英文 */
  lang: 'zh' | 'en';
  /** 来源渠道 1 小程序 2 H5 3 web-官网 */
  channel: 1 | 2 | 3;
}

export const emailLogin = async (data: IEmailLoginData) =>
  request<{ data: IUserInfo }>({
    method: 'POST',
    url: '/login/loginCheck',
    data,
  });

export const phoneLogin = async (data: IEmailLoginData) =>
  request<{ data: IUserInfo }>({
    method: 'POST',
    url: '/login/loginMsgCheck',
    data,
  });

/**
 * 获取历史消息列表
 * @returns
 */
export const getHistoryChat = async () =>
  request<IHistoryChat>({
    method: 'GET',
    url: '/chat/historyTopicWeb',
  });

/**
 * 获取当前 id 下的历史消息
 * @param topicId 对话 id
 * @returns
 */
export const getChatHistoryMessages = async (topicId?: string) =>
  request<ChatResponse>({
    method: 'GET',
    url: `/chat/topicChat?pageNo=1&pageSize=1000&topicId=${topicId}`,
  });

export const getMoreList = async (params: { lang: string }) =>
  request<{ data: Question[] }>({
    method: 'GET',
    url: `/chat/moreListWeb`,
    params,
  });

/**
 * chat/chatLimits
 */
export const getChatLimits = async () =>
  request<{ data: { limitStatus: boolean; limits: number } }>({
    method: 'GET',
    url: `chat/chatLimits`,
  });
